import React, { ReactElement, ReactNode, RefObject } from 'react'
// CSS imports. Commented out because of current build process.
// import './button.scss';

/**
 * Component properties type.
 */
export type ButtonProps = {
    onClick?: (event: React.MouseEvent) => void
    customClass?: string
    href?: string
    popoverRef?: RefObject<HTMLButtonElement>
    // TODO remove prop label
    label?: string | ReactElement
    download?: boolean
    isDisabled?: boolean
    isOutlined?: boolean
    children?: ReactNode
    type?: 'button' | 'submit' | 'reset' | undefined
    fullWidth?: boolean
}

/**
 * Basic button component.
 *
 * @param onClick Click handler.
 * @param customClass Custom css class.
 * @param href href link.
 * @param label button label.
 * @param download Download html property.
 * @param isDisabled Button enabled/disabled.
 * @param isOutlined Button outline styling.
 */
const Button: React.FC<ButtonProps> = ({
    onClick,
    customClass,
    popoverRef,
    href,
    label,
    download,
    isDisabled,
    isOutlined,
    children,
    type,
    fullWidth
}: ButtonProps): ReactElement => {
    // Common properties used in both button types.
    const commonButtonProps = {
        className: `button ${customClass || ''} ${isDisabled ? 'disabled' : ''} ${isOutlined ? 'outlined' : ''} ${
            fullWidth ? 'full-width' : ''
        }`,
        onClick: isDisabled ? undefined : onClick
    }

    return href ? (
        <a {...commonButtonProps} href={isDisabled ? '#' : href} download={isDisabled ? false : download}>
            <span>
                {children}
                {label}
            </span>
        </a>
    ) : (
        <button type={type} {...commonButtonProps} disabled={isDisabled} ref={popoverRef}>
            <span>
                {children}
                {label}
            </span>
        </button>
    )
}

export default Button
